import {LightEmployee} from "../../interfaces/employees/light-employee";
import {Employee} from '../../interfaces/core/employee';


export class LightEmployeeFactory {

  /**
   *
   * @param lightEmployee
   */
  public static fromObject(lightEmployee: any): LightEmployee {
    return new class implements LightEmployee {
      customId: number = lightEmployee.custom_id;
      firstName: string = lightEmployee.first_name;
      fullName: string = lightEmployee.full_name;
      titleBefore: string = lightEmployee.title_before;
      titleAfter: string = lightEmployee.title_after;
      id: number = lightEmployee.id;
      lastName: string = lightEmployee.last_name;
      profilePictureUrl: null = lightEmployee.profile_picture_url;
      serviceFacilityDomainId: number = lightEmployee.service_facility_domain_id;
      serviceFacilityId: number = lightEmployee.service_facility_id;
      serviceId: number = lightEmployee.service_id;
      shortmark: string = lightEmployee.shortmark;
      isPfa: boolean = typeof lightEmployee.is_pfa === 'undefined' ? false : lightEmployee.is_pfa;
      phoneNumberCompany: string = lightEmployee.phone_number_company;
      name: string = lightEmployee.last_name + ' ' + lightEmployee.first_name;
      isWorkingToday: boolean = lightEmployee.em_employments ? lightEmployee.em_employments.length > 0 : false;
    };
  }

  /**
   *
   * @param lightEmployees
   */
  public static fromArray(lightEmployees: any[]): LightEmployee[] {
    return lightEmployees.map(_lightEmployee => LightEmployeeFactory.fromObject(_lightEmployee));
  }

  /**
   *
   */
  public static fromEmployee(employee: Employee): LightEmployee {
    return new class implements LightEmployee {
      customId: number = employee.customId;
      titleBefore: string = employee.titleBefore;
      titleAfter: string = employee.titleAfter;
      firstName: string = employee.firstName;
      lastName: string = employee.lastName;
      fullName: string = employee.fullName;
      id: number = employee.id;
      isPfa: boolean = employee.isPfa;
      name: string = employee.name;
      phoneNumberCompany: string = employee.phoneNumberCompany;
      profilePictureUrl: string = employee.profilePictureUrl;
      serviceFacilityId: number = employee.serviceFacilityId;
      serviceId: number = employee.serviceId;
      shortmark: string = null;
    };
  }

}
